// Isolated module for SharedWorker creation.
// import.meta.url cannot be parsed by Jest, so this file is fully mocked in tests.
export const createSocketWorker = (): SharedWorker | null => {
    // Android WebViews (including Telegram on some devices) may not expose SharedWorker at all. `typeof`
    // is required here: reading the missing global directly throws before the application can render.
    if (typeof SharedWorker === 'undefined') return null
    try {
        return new SharedWorker(new URL('./socketWorker.ts', import.meta.url), { type: 'module', name: 'numeo-socket' })
    } catch (error) {
        // A browser can expose the constructor but reject creation because of its origin/security policy.
        console.warn('[WebSocket] SharedWorker creation failed; real-time updates are unavailable.', error)
        return null
    }
}
